<template>
  <!-- eslint-disable max-len -->
  <button
    @click="toggleAudio"
    :aria-label="`${this.isPlaying ? 'Pause' : 'Play'} instructions`"
    :disabled="!hasAudioLoaded"
    id="toggleAudioButton"
    tabindex="8"
  >
    <div v-if="isPlaying" class="icon-video-pause" style="height: 40px; width: 40px"></div>
    <div v-else class="icon-video-play" style="height: 40px; width: 40px"></div>
  </button>
</template>

<script>
import { activity, mapState } from '../../store/helpers';

export default {
  props: {
    onInstructionsVoiced: {
      default: () => null,
      type: Function,
      required: false
    },
    syncOnRender: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapState(activity, ['instructionsAudio', 'instructionsAudios'])
  },

  data() {
    return {
      hasAudioLoaded: false,
      indexOfAudioPlaying: 0,
      isPlaying: false
    };
  },

  methods: {
    attachInstructionsAudioListeners() {
      this.hasAudioLoaded = true;

      this.instructionsAudio.on('play', () => {
        this.isPlaying = true;
      });
      this.instructionsAudio.on('pause', () => {
        this.isPlaying = false;
      });
      this.instructionsAudio.on('end', () => {
        this.isPlaying = false;
        this.onInstructionsVoiced();
      });
    },
    attachInstructionsAudiosListeners() {
      this.hasAudioLoaded = true;

      this.instructionsAudios[1].on('play', () => {
        this.isPlaying = true;
      });
      this.instructionsAudios[1].on('pause', () => {
        this.isPlaying = false;
      });
      this.instructionsAudios[1].on('end', () => {
        this.indexOfAudioPlaying = 0;
        this.isPlaying = false;
        this.onInstructionsVoiced();
      });

      this.instructionsAudios[0].on('play', () => {
        this.indexOfAudioPlaying = 0;
        this.isPlaying = true;
      });
      this.instructionsAudios[0].on('pause', () => {
        this.isPlaying = false;
      });
      this.instructionsAudios[0].on('end', () => {
        // Currently only handling playing two audios back to back
        setTimeout(() => {
          this.indexOfAudioPlaying = 1;
          this.instructionsAudios[1].play();
        }, 500);
      });
    },
    toggleAudio() {
      if (this.instructionsAudios) {
        this.instructionsAudios[this.indexOfAudioPlaying][this.isPlaying ? 'pause' : 'play']();
      } else {
        this.instructionsAudio[this.isPlaying ? 'pause' : 'play']();
      }
    }
  },

  mounted() {
    if (this.syncOnRender) {
      if (this.instructionsAudio) {
        this.attachInstructionsAudioListeners();
      } else if (this.instructionsAudios) {
        this.attachInstructionsAudiosListeners();
      }
    }
  },

  watch: {
    instructionsAudio(currentAudio) {
      if (currentAudio) {
        this.attachInstructionsAudioListeners();
      }
    },
    instructionsAudios(currentAudios) {
      if (currentAudios) {
        this.attachInstructionsAudiosListeners();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#toggleAudioButton {
  background: transparent;
  border: none;
  height: 40px;
  padding: 0px;
  width: 40px;

  svg {
    position: relative;
    left: 1px;
    top: 1px;
  }

  &:disabled {
    svg {
      opacity: 0.3;
    }
  }

  &:focus-visible {
    outline: 5px auto #015f cc;
  }
}
</style>
